import React, { useEffect, useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import ImagePreview from "../../../../components/Common/ImagePreview";

// img
import v1 from "../../../../Assets/images/v1.png";
import { Rating } from "../../../../components/Common/Common";
import { Link, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { GET_MANAGE_VENDOR_DETAILS } from "../../../../services/ApiCalls";
import StarRating from "../../CustomerDetail/Component/StarComp";
import GuestAssignDriver from "../AssignDriver";

const VendorDetail = () => {
  const { id } = useParams();
  const [bookingDetails, setBoookingDetails] = useState();
  const [showModal, setShowModal] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  console.log(bookingDetails, "asdasdasd");
  const [showModalAssign, setShowModalAssign] = useState(false);

  const handleAssignDriver = () => {
    setShowModalAssign(true);
    //   navigate("/assign-driver");
  };

  const handleAssignClose = () => {
    setShowModalAssign(false);
  };


  // ....Customer Rating.... //
  const newerev = bookingDetails?.reviews?.given;
  const customerRatings = newerev?.map((review) => review.rating) ?? [];
  const customerRating =
    customerRatings.length > 0
      ? customerRatings.reduce((sum, rating) => sum + rating, 0) /
      customerRatings.length
      : 0;

  // ....Driver Rating.... //
  const newerevDriver = bookingDetails?.reviews?.received;
  const driverRatings = newerevDriver?.map((review) => review.rating) ?? [];
  const driverRating =
    driverRatings.length > 0
      ? driverRatings.reduce((sum, rating) => sum + rating, 0) /
      driverRatings.length
      : 0;

  const handleImageClick = (image) => {
    setSelectedImage(image);
    setShowModal(true);
  };

  const handleClose = () => {
    setShowModal(false);
    setSelectedImage(null);
  };
  const getBookingDetails = async () => {
    try {
      const res = await GET_MANAGE_VENDOR_DETAILS(id);
      if (res?.data?.status === "success") {
        setBoookingDetails(res?.data?.data);
      } else {
        toast.error(res?.data?.message);
      }
    } catch (error) {
      console.log(error);
      toast.error("something went wrong");
    }
  };

  useEffect(() => {
    if (id) getBookingDetails();
  }, [id]);


  return (
    <>
      <section className="bookingDetail py-3">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <Link to="/guest-booking" className="">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="41"
                  height="41"
                  viewBox="0 0 41 41"
                  fill="none"
                >
                  <rect
                    x="0.5"
                    y="0.5"
                    width="40"
                    height="40"
                    rx="11.5"
                    fill="white"
                    stroke="#D9DADC"
                  />
                  <path
                    d="M23.1573 13.3669C23.0654 13.2747 22.9562 13.2016 22.836 13.1517C22.7157 13.1019 22.5869 13.0762 22.4567 13.0762C22.3265 13.0762 22.1976 13.1019 22.0774 13.1517C21.9572 13.2016 21.848 13.2747 21.7561 13.3669L15.1773 19.9456C15.1039 20.0189 15.0457 20.1059 15.006 20.2017C14.9662 20.2974 14.9458 20.4001 14.9458 20.5038C14.9458 20.6075 14.9662 20.7101 15.006 20.8059C15.0457 20.9017 15.1039 20.9887 15.1773 21.0619L21.7561 27.6406C22.144 28.0286 22.7694 28.0286 23.1573 27.6406C23.5452 27.2527 23.5452 26.6273 23.1573 26.2394L17.4257 20.4998L23.1652 14.7602C23.5452 14.3802 23.5452 13.7469 23.1573 13.3669Z"
                    fill="#1E232C"
                    stroke="#1E232C"
                    stroke-width="0.2"
                  />
                </svg>
              </Link>
            </Col>

            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">
                Customer Details:
              </h5>
              <div
                className="cardCstm border rounded px-3 py-2"
                style={{ height: "14rem" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  {/* <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <Col lg="4" className="">
                      <div className="inner h-100  pb-2 mt-2">
                        <span className="w-50 text-muted fw-sbold">
                          Customer Image:
                        </span>
                        {(Array.isArray(bookingDetails?.profileImage)
                          ? bookingDetails?.profileImage
                          : [bookingDetails?.profileImage]
                        )?.map((item, index) => (
                          <div key={index} className="mb-3">
                            <img
                              src={item || v1}
                              alt=""
                              width={100}
                              height={100}
                            />
                          </div>
                        ))}
                      </div>
                    </Col>
                  </li> */}
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Customer Name:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.customerName}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Email ID:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.customerEmail}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Phone Number:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.customerCountryCode && bookingDetails?.booking?.customerCountryCode +
                        " " +
                        bookingDetails?.booking?.customerMobileNumber}
                    </p>
                  </li>
                  {/* <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold"> 
                      Ratings Received From Driver:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      
                      <StarRating averageRating={customerRating} />
                    </p>
                  </li> */}
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Service Type:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.serviceType}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Vendor Details:</h5>
              <div
                className="cardCstm border rounded px-3 py-2"
                style={{ height: "14rem" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Name:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.vendorDetails?.name}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Email id:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.vendorDetails?.email}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Phone number:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.vendorDetails?.countryCode +
                        " " +
                        bookingDetails?.booking?.vendorDetails?.mobileNumber}
                    </p>
                  </li>
                  {/* <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Ratings Received From Customer:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      
                      <StarRating averageRating={driverRating} />
                    </p>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Driver Details:</h5>
              <div
                className="cardCstm border rounded px-3 py-2"
                style={{ height: "14rem" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Name:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.driverDetails?.name}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Email id:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.driverDetails?.email}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Phone number:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.driverDetails?.countryCode && bookingDetails?.booking?.driverDetails?.mobileNumber && (bookingDetails?.booking?.driverDetails?.countryCode +
                        " " +
                        bookingDetails?.booking?.driverDetails?.mobileNumber)}
                    </p>
                  </li>
                  {/* <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Ratings Received From Customer:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      
                      <StarRating averageRating={driverRating} />
                    </p>
                  </li> */}
                </ul>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Booking Details:</h5>
              <div className="cardCstm border rounded px-3 py-2">
                <Row>
                  <Col lg="6" className="my-2">
                    <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                      <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <span className="w-50 text-muted fw-sbold">
                          Pick Up Location:
                        </span>
                        <p className="m-0 text-danger w-50 fw-sbold">
                          {bookingDetails?.booking?.pickUp?.address}
                        </p>
                      </li>
                      <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <span className="w-50 text-muted fw-sbold">
                          Drop Location:
                        </span>
                        <p className="m-0 text-danger w-50 fw-sbold">
                          {bookingDetails?.booking?.dropOff?.address}
                        </p>
                      </li>
                      <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <span className="w-50 text-muted fw-sbold">
                          Total Distance:
                        </span>
                        <p className="m-0 text-danger w-50 fw-sbold">
                          {bookingDetails?.booking?.distance.slice(0, 4)} Miles
                        </p>
                      </li>
                    </ul>
                  </Col>
                  <Col lg="6" className="my-2">
                    <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                      {bookingDetails?.duration ? (
                        <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                          <span className="w-50 text-muted fw-sbold">
                            Total Duration:
                          </span>
                          <p className="m-0 text-danger w-50 fw-sbold">
                            {bookingDetails.duration}
                          </p>
                        </li>
                      ) : null}
                      <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <span className="w-50 text-muted fw-sbold">
                          {/* Booking Amount: */}
                          Paid Amount:
                        </span>
                        <p className="m-0 text-danger w-50 fw-sbold">
                          ${bookingDetails?.booking?.dropOff?.estimatedAmount}
                        </p>
                      </li>
                      {/* <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <span className="w-50 text-muted fw-sbold">
                        
                          Customer Offer Price:
                        </span>
                        <p className="m-0 text-danger w-50 fw-sbold">
                          ${bookingDetails?.booking?.totalOffer}
                        </p>
                      </li> */}
                      {/* <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <span className="w-50 text-muted fw-sbold">
                          Driver/Agency Offer Price:
                        </span>
                        <p className="m-0 text-danger w-50 fw-sbold">
                          ${bookingDetails?.booking?.bidAmount || "0"}
                        </p>
                      </li> */}
                      {/* <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                        <span className="w-50 text-muted fw-sbold">OTP:</span>
                        <p className="m-0 text-danger w-50 fw-sbold">
                          {bookingDetails?.booking?.startOTP}
                        </p>
                      </li> */}
                    </ul>
                  </Col>
                </Row>
              </div>
            </Col>
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Earning:</h5>
              <div
                className="cardCstm border rounded px-3 py-2"
                style={{ height: "11.5rem" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Payment Method:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.paymentMethod}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Vendor Earning:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      ${bookingDetails?.booking?.vendorCommission}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Driver Earning:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      ${bookingDetails?.booking?.providerCommission || 0}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Admin Earning:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      ${bookingDetails?.booking?.adminCommission}
                    </p>
                  </li>
                </ul>
              </div>
            </Col>
            {/* <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Booking Details:</h5>
              <div className="cardCstm border rounded px-3 py-2">
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Payment Method:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">{bookingDetails?.paymentMethod}</p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Driver Earning:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      ${bookingDetails?.providerCommission}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Admin Earning:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      ${bookingDetails?.adminCommission}
                    </p>
                  </li>
                </ul>
              </div>
            </Col> */}
            <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Image Uploaded:</h5>
              <div className="cardCstm border rounded px-3 py-2">
                <Row>
                  <Col lg="4" className="">
                    <div
                      className="inner h-100  pb-2 mt-2"
                      style={{ height: "11.5rem" }}
                    >
                      <h6 className="m-0 py-2 fw-bold themeBlue">
                        Pickup Image:
                      </h6>
                      {(Array.isArray(
                        bookingDetails?.booking?.serviceStartImage
                      )
                        ? bookingDetails?.booking?.serviceStartImage
                        : [bookingDetails?.booking?.serviceStartImage]
                      )?.map((item, index) => (
                        <div key={index} className="mb-3">
                          <img
                            src={item || v1}
                            alt=""
                            width={100}
                            height={100}
                            onClick={() => handleImageClick(item || v1)}
                            style={{ cursor: "pointer" }}
                          />
                          <ImagePreview
                            showModal={showModal}
                            selectedImage={selectedImage}
                            onClose={handleClose}
                          // title="Pickup Image Preview"
                          />
                        </div>
                      ))}
                    </div>
                  </Col>

                  <Col lg="4" className="">
                    <div className="inner h-100  pb-2 mt-2">
                      <h6 className="m-0 py-2 fw-bold themeBlue">
                        Dropoff Image:
                      </h6>
                      {(Array.isArray(bookingDetails?.booking?.serviceEndImage)
                        ? bookingDetails?.booking?.serviceEndImage
                        : [bookingDetails?.booking?.serviceEndImage]
                      )?.map((item, index) => (
                        <div key={index} className="mb-3">
                          <img
                            src={item || v1}
                            alt=""
                            width={100}
                            height={100}
                            onClick={() => handleImageClick(item || v1)}
                            style={{ cursor: "pointer" }}
                          />
                          <ImagePreview
                            showModal={showModal}
                            selectedImage={selectedImage}
                            onClose={handleClose}
                            title="DropOff Image Preview"
                          />
                        </div>
                      ))}
                    </div>
                  </Col>
                </Row>
              </div>
            </Col>


            {/* <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Customer Details:</h5>
              <div className="cardCstm border rounded px-3 py-2">
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Name:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {" "}
                      {bookingDetails?.customerDetails?.name}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Email id:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.customerDetails?.email}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">Phone number:</span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.customerDetails?.mobileNumber}
                    </p>
                  </li>
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Ratings Received From Customer:
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      <Rating size={18} />
                    </p>
                  </li>
                </ul>
              </div>
            </Col> */}

            {/* <Col lg="6" className="my-2">
              <h5 className="m-0 pb-2 fw-sbold themeBlue ">Service Type:</h5>
              <div
                className="cardCstm border rounded px-3 py-2"
                // style={{ height: "11.5rem" }}
              >
                <ul className="list-unstyled ps-0 mb-0 noLastBorder">
                  <li className="py-2 d-flex align-items-center justify-content-between gap-10">
                    <span className="w-50 text-muted fw-sbold">
                      Service Type
                    </span>
                    <p className="m-0 text-danger w-50 fw-sbold">
                      {bookingDetails?.booking?.serviceType}
                    </p>
                  </li>
                </ul>
              </div>
            </Col> */}
          </Row>
        </Container>
      </section>
    </>
  );
};

export default VendorDetail;
